import { Nullable } from '../../types/common'
import { hideElement, showElement } from '../../utils/dom'
import BaseComponent from '../base-component/base-component'
import CartDrawer from './cart-drawer'

class CartDrawerRelatedProductsBlock extends BaseComponent {
  cartDrawer: Nullable<CartDrawer>
  relatedProducts: Nullable<HTMLElement>
  isAutoRecommendations: boolean

  constructor() {
    super()

    this.relatedProducts = this.querySelector(
      '[data-cart-drawer-related-products]',
    )
    this.cartDrawer = this.closest('cart-drawer')
    this.isAutoRecommendations = this.hasAttribute('is-auto-recommendations')
  }

  connectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.subscribe(
        'update-nodes',
        this.handleCartDrawerFinishUpdate,
      )
    }
  }

  disconnectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.unsubscribe(
        'update-nodes',
        this.handleCartDrawerFinishUpdate,
      )
    }
  }

  handleCartDrawerFinishUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  checkHasAsideProducts(): void {
    const isAsideProducts = this.hasAttribute('is-aside-related-products')

    if (isAsideProducts) {
      const products = document.querySelectorAll(
        '[is-aside-related-products] vertical-product-card',
      )
      const hasAsideProducts = products?.length > 0
      const cartDrawer = document.querySelector('cart-drawer')

      if (cartDrawer) {
        cartDrawer.toggleAttribute('has-aside-products', hasAsideProducts)
      }
    }
  }

  updateByNode(node: HTMLElement): void {
    if (!this.relatedProducts) {
      return
    }

    const blockId = this.getAttribute('block-id')
    const newRelatedProducts = node.querySelector(
      `cart-drawer-related-products-block[block-id="${blockId}"] [data-cart-drawer-related-products]`,
    )

    if (!newRelatedProducts) {
      return
    }

    if (this.isAutoRecommendations) {
      const newUrl = newRelatedProducts.getAttribute('data-url')

      this.relatedProducts.setAttribute('data-url', newUrl)

      if (newUrl) {
        this.relatedProducts.loadProducts()
        // showElement(this)
      } else {
        this.relatedProducts.erase()
        // hideElement(this)
        this.checkHasAsideProducts()
      }
    } else {
      const clonedNewRelatedProducts = newRelatedProducts.cloneNode(true)

      this.relatedProducts.replaceChildren(
        ...clonedNewRelatedProducts.childNodes,
      )
      this.checkHasAsideProducts()
    }
  }
}

export default CartDrawerRelatedProductsBlock
